import { useTranslation } from "react-i18next";
import { useEmployee } from "../../../../providers/EmployeeProvider";
import { Tab, Tabs } from "@mui/material";

export default function DriverTabSelector(props) {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const { activeMissions, completedMissions } = useEmployee();

  return (
    <Tabs onChange={onChange} value={value} variant="fullWidth" >
      <Tab value={0} label={`${t("myMissions:activeMissionsTab")} (${activeMissions.length})`} />
      <Tab value={1} label={`${t("myMissions:completedMissionsTab")} (${completedMissions.length})`} />
    </Tabs>
  );
}
